export default __webpack_public_path__ + "static/media/randomqoutegenerator.199af918.gif";